import { render } from "./SystemUserAvatarGroup.vue?vue&type=template&id=9f2ec968"
import script from "./SystemUserAvatarGroup.vue?vue&type=script&lang=js"
export * from "./SystemUserAvatarGroup.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__